import { render, staticRenderFns } from "./GenericList.vue?vue&type=template&id=017ddfdc&scoped=true&"
import script from "./GenericList.vue?vue&type=script&lang=js&"
export * from "./GenericList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017ddfdc",
  null
  
)

export default component.exports